/* Built In Imports */
import * as React from 'react';
import { useEffect, useState } from 'react';

/* External Imports */
import YouTube from 'react-youtube';

 const LiteYouTubeEmbed=(props)=> {
  const [opts, setOpts] = useState({});
  const [preconnected, setPreconnected] = useState(false);
  const [iframe, setIframe] = useState(false);
  const videoId = encodeURIComponent(props.id);
  const videoTitle = props.title;
  const posterImp = props.poster || 'hqdefault';
  const announceWatch = props.announce || 'Watch';
  const format = props.webp ? 'webp' : 'jpg';
  const vi = props.webp ? 'vi_webp' : 'vi';
  const posterUrl =
    props.thumbnail ||
    `https://i.ytimg.com/${vi}/${videoId}/${posterImp}.${format}`;

  let ytUrl = props.noCookie
    ? 'https://www.youtube-nocookie.com'
    : 'https://www.youtube.com';
  ytUrl = props.cookie
    ? 'https://www.youtube.com'
    : 'https://www.youtube-nocookie.com';

  const activatedClassImp = props.activatedClass || 'lyt-activated';
  const adNetworkImp = props.adNetwork || false;
  const aspectHeight = props.aspectHeight || 9;
  const aspectWidth = props.aspectWidth || 16;
  const playerClassImp = props.playerClass || 'lty-playbtn';
  const wrapperClassImp = props.wrapperClass || 'yt-lite';
  const rel = props.rel ? 'prefetch' : 'preload';

  const warmConnections = () => {
    if (preconnected) return;
    setPreconnected(true);
  };

  const addIframe = () => {
    if (iframe) return;
    setIframe(true);
  };

  useEffect(() => {
    setOpts({
      height: '100%',
      width: '100%',
      playerVars: {
        autoplay: 1,
      },
    });
  }, [global?.window]);

  const onReady = event => {
    event.target.playVideo();
  };

  return (
    <>
      <link rel={rel} href={posterUrl} as="image" />
      <>
        {preconnected && (
          <>
            <link rel="preconnect" href={ytUrl} />
            <link rel="preconnect" href="https://www.google.com" />
            {adNetworkImp && (
              <>
                <link rel="preconnect" href="https://static.doubleclick.net" />
                <link
                  rel="preconnect"
                  href="https://googleads.g.doubleclick.net"
                />
              </>
            )}
          </>
        )}
      </>
      <article
        onPointerOver={warmConnections}
        onClick={addIframe}
        className={`${wrapperClassImp} ${iframe ? activatedClassImp : ''}`}
        data-title={videoTitle}
        style={{
          backgroundImage: !iframe ? `url(${posterUrl})` : '#000',
          ...{
            '--aspect-ratio': `${(aspectHeight / aspectWidth) * 100}%`,
          },
        }}
      >
        <button
          type="button"
          className={playerClassImp}
          aria-label={`${announceWatch} ${videoTitle}`}
        />
        {iframe && (
          <YouTube
            videoId={props.embedUrl}
            onReady={onReady}
            opts={opts}
            style={{
              position: 'absolute',
              width: '100%',
              height: '100%',
              top: '0',
              left: '0',
            }}
          />
        )}
      </article>
    </>
  );
}
export default LiteYouTubeEmbed;
